"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _dropdown = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _listGroup = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/list-group"));

var _chip = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/chip"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/destination/icons/ArrowDropdown"));

var _constants = require("./constants");

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContentTypeSelection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentTypeSelection, _Component);

  var _super = _createSuper(ContentTypeSelection);

  function ContentTypeSelection(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentTypeSelection);
    _this = _super.call(this, props);
    _this.onToggleContentType = _this.onToggleContentType.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeSelectedContentType = _this.removeSelectedContentType.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContentTypeSelection, [{
    key: "onToggleContentType",
    value: function onToggleContentType(contentType, enabled) {
      var _this$props = this.props,
          selectedContentTypes = _this$props.selectedContentTypes,
          onChange = _this$props.onChange;
      var newSelectedContentTypes;

      if (enabled) {
        newSelectedContentTypes = [].concat((0, _toConsumableArray2.default)(selectedContentTypes), [contentType]);
        return onChange(newSelectedContentTypes);
      }

      var isOnlySelectedContentType = selectedContentTypes.length === 1 && selectedContentTypes.includes(contentType);
      if (isOnlySelectedContentType) return onChange(ContentTypeSelection.getListOfContentTypes());
      newSelectedContentTypes = selectedContentTypes.filter(function (item) {
        return item !== contentType;
      });
      onChange(newSelectedContentTypes);
    }
  }, {
    key: "removeSelectedContentType",
    value: function removeSelectedContentType(contentType) {
      var _this$props2 = this.props,
          selectedContentTypes = _this$props2.selectedContentTypes,
          onChange = _this$props2.onChange;
      var isOnlySelectedContentType = selectedContentTypes.length === 1 && selectedContentTypes.includes(contentType);
      if (isOnlySelectedContentType) return onChange(ContentTypeSelection.getListOfContentTypes());
      var newSelectedContentTypes = selectedContentTypes.filter(function (item) {
        return item !== contentType;
      });
      onChange(newSelectedContentTypes);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var selectedContentTypes = this.props.selectedContentTypes;
      var contentTypes = (0, _constants.getContentTypes)();
      var contentTypesMapping = (0, _constants.getContentTypesMapping)();
      return (0, _preact.h)("div", null, (0, _preact.h)(_dropdown.default, {
        size: "full-width",
        textButtonStyle: {
          width: '100%',
          marginBottom: '8px'
        },
        isControl: true,
        customHeight: "250px",
        popupName: "dynamic-content-widget_content-type-selection",
        trigger: (0, _preact.h)("div", {
          className: "dynamic-content-widget_dropdown-selection"
        }, (0, _preact.h)("label", {
          htmlFor: "dynamic-content-widget_dropdown-selection"
        }, "Content Types"), (0, _preact.h)(_Button.default, {
          icon: (0, _preact.h)(_ArrowDropdown.default, {
            width: 16,
            height: 16
          }),
          title: "Select content types",
          fullWidth: true,
          size: "medium",
          style: {
            fontWeight: 'normal'
          },
          id: "dynamic-content-widget_dropdown-selection"
        }))
      }, (0, _preact.h)(_NestedDropdown.default, {
        items: contentTypesMapping,
        selectedItems: selectedContentTypes,
        onSelectItem: function onSelectItem(contentType) {
          return _this2.onToggleContentType(contentType, !selectedContentTypes.includes(contentType));
        },
        onMultiSelect: function onMultiSelect(contentType, checked) {
          return _this2.onToggleContentType(contentType, checked);
        },
        depth: 1
      })), selectedContentTypes.length > 0 && (0, _preact.h)(_listGroup.default, {
        spacing: "4px"
      }, selectedContentTypes.map(function (contentType) {
        return (0, _preact.h)(_chip.default, {
          key: contentType,
          variant: "squared",
          size: "small",
          endIcon: (0, _preact.h)(_Close.default, {
            width: 14,
            height: 14
          }),
          onClick: function onClick() {
            _this2.removeSelectedContentType(contentType);
          }
        }, contentTypes[contentType]);
      })));
    }
  }], [{
    key: "getListOfContentTypes",
    value: function getListOfContentTypes() {
      return Object.keys((0, _constants.getContentTypes)());
    }
  }]);
  return ContentTypeSelection;
}(_preact.Component);

var _default = ContentTypeSelection;
exports.default = _default;